import { cn } from "@/lib/formatters";

interface StrikingBadgeProps {
  striking: boolean;
  className?: string;
}

export function StrikingBadge({ striking, className }: StrikingBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm font-mono text-xs uppercase tracking-wider",
        striking
          ? "bg-primary/10 text-primary border border-primary/30"
          : "bg-bg-elev text-muted border border-border",
        className,
      )}
    >
      <span
        className={cn(
          "inline-block w-1.5 h-1.5 rounded-full bg-current",
          striking && "animate-pulse-led",
        )}
      />
      {striking ? "striking" : "off-range"}
    </span>
  );
}
